<template>
    <div class="apaympro-container">

        <!-- Top Bar Component --> 
        <top-bar></top-bar> 
        <!-- Top Bar Component -->

        <!-- Form Payment -->
        <div class="apaympro-wrapper animated fadeIn container custom-width">
            <div class="apaympro-page">

                <!-- Header -->
                <div class="apaympro-header mb-3">
                    <div class="page-info">
                        <h3 
                            class="page-name mb-2"
                            style="
                                font-weight: 800;
                                font-size: 1.6rem;
                            "
                        >
                            Bienvenue sur APAYM Cabine !
                        </h3>
                        <span class="text-muted">
                            Effectuer vos opérations en toute tranquilité.
                        </span>
                    </div>
                </div>
                <!-- Header -->

                <!-- Body -->
                <div class="body animated fadeIn">
                    
                    <div class="element-pair mt-5 mb-3">

                        <div class="element-pair-container menu-container">

                            <div class="row mt-5"> 

                                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 menu-cabine text-center">
                                    <div class="card border-0 shadow-md mb-4" style="border-radius: 1rem;">
                                        <!-- <router-link to="rechargement-visa">
                                            <div class="card-body">
                                                <img class="rounded-sm mb-4" src="../assets/img/icons/rechargement-visa.png" alt="image">
                                                <p class="card-text text-center text-dark" style="font-weight: 800;">
                                                    Recharger vos cartes Visa
                                                </p>
                                            </div>
                                        </router-link> -->
                                        <a href="javascript:;"  @click="unavailable">
                                            <div class="card-body">
                                                <img class="rounded-sm mb-4" src="../assets/img/icons/rechargement-visa.png" alt="image">
                                                <p class="card-text text-center text-dark" style="font-weight: 800;">
                                                    Recharger vos cartes Visa
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 menu-cabine"> 
                                    <div class="card border-0 shadow-md mb-4" style="border-radius: 1rem;">
                                        <!-- <a href="https://carte.abidjan.net/commander-votre-carte/" target="_blank"> -->
                                        <router-link to="cartes">
                                            <div class="card-body">
                                                <img class="rounded-sm mb-4" src="../assets/img/icons/achat-carte.png" alt="image">
                                                <p class="card-text text-center text-dark" style="font-weight: 800;">
                                                    Acheter des cartes Visa
                                                </p>
                                            </div>
                                        </router-link>
                                        <!-- </a> -->
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 menu-cabine">
                                    <div class="card border-0 shadow-md mb-4" style="border-radius: 1rem;">
                                        <a href="https://pay.apaym.com/abidjannettaxi" target="_blank">
                                            <div class="card-body">
                                                <img class="rounded-sm mb-4" src="../assets/img/icons/yango.png" alt="image">
                                                <p class="card-text text-center text-dark" style="font-weight: 800;">
                                                    Recharger des comptes Yango
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 menu-cabine">
                                    <div class="card border-0 shadow-md mb-4" @click="soonAvailable" style="border-radius: 1rem;">
                                        <div class="card-body">
                                            <img class="rounded-sm mb-4" src="../assets/img/icons/credit-telephonique.png" alt="image">
                                            <p class="card-text text-center" style="font-weight: 800;">
                                                Acheter du crédit téléphonique
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 menu-cabine">
                                    <div class="card border-0 shadow-md mb-4" @click="soonAvailable" style="border-radius: 1rem;">
                                        <div class="card-body">
                                            <img class="rounded-sm mb-4" src="../assets/img/icons/facture.png" alt="image">
                                            <p class="card-text text-center" style="font-weight: 800;">
                                                Paiement de vos factures
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 menu-cabine">
                                    <div class="card border-0 shadow-md mb-4" style="border-radius: 1rem;">
                                        <a href="https://pay.apaym.com/" target="_blank">
                                            <div class="card-body">
                                                <img class="rounded-sm mb-4" src="../assets/img/icons/marchand.png" alt="image">
                                                <p class="card-text text-center text-dark" style="font-weight: 800;">
                                                    Payer un marchand APAYM Pro
                                                </p>
                                            </div>
                                        </a>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                </div>
                <!-- Body -->
            </div>
        </div>
        <!-- Form Payment -->


        <!-- Footer APAYM Secured Badge -->
        <footer-item></footer-item>
        <!-- Footer APAYM Secured Badge -->
 
    </div>
</template>


<script>

    import TopBar from "../components/TopBar" ;
    import FooterItem from "../components/FooterItem" ;

    export default {
        name: 'HomePage',
        metaInfo() {
            return {
                title: "Page d'accueil | APAYM Cabine",
                meta: [
                    {
                        vmid: "description",
                        name: "description",
                        content:
                            "APAYM Cabine est une plateforme qui vous permets de faire le rechargement de vos " +
                            "cartes Visa via les mobiles money, d'acheter du crédit téléphonique, de commander des cartes, " +
                            "de faire le rechargement de votre compte Yango, ainsi que le paiement de vos factures."
                    }
                ]
            };
        },
        components: {
            'top-bar': TopBar,
            'footer-item': FooterItem
        },
        data() {
            return {
            }
        },
        computed: {
        },
        methods: {
            soonAvailable(){
                this.$swal({
                    title: 'Information',
                    icon: 'info',
                    html:"<strong class='font-16' style='line-height: 1.2'>Le service est en cours d'implémentation, il sera bientôt disponible !</strong>",
                });
            },

            unavailable(){
                this.$swal({
                    title: 'Information',
                    icon: 'info',
                    html:"<strong class='font-16' style='line-height: 1.2'>Le service est momentanément indisponible !</strong>",
                });
            }
        },

        mounted() 
        {
        },

        updated() 
        {
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .menu-cabine {
        /* padding: 28px; */
        /* margin: 0 auto; */
        cursor: pointer;
    }

    .menu-cabine:hover, .menu-cabine:focus{
        /* padding: 28px; */
        /* margin: 0 auto; */
        cursor: pointer;
        /* border-radius: 5px; */
        /* box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px; */
    }

    .menu-container{
        display: block;
        margin-left: -35px;
        margin-right: -35px;
    }

    .custom-row-menu {
        margin-top: 3rem !important;
    }

    @media screen and (max-width: 576px){
        
        .menu-container{
            display: block;
            margin-left: 0px;
            margin-right: 0px;
            padding-left: 20px;
            padding-right: 20px;
        }

        .custom-row-menu {
            margin-top: 0 !important;
        }
    }
  
</style>
